export const USER_CONSENTS = [
    'Informujemy, że Administratorem Danych Osobowych jest Egurrola Dance Studio Sp. z o. o. z siedzibą w Warszawie (02-001), Aleje Jerozolimskie 91, NIP 7010002530, e-mail: rodo@egurrola.pl. Dane kontaktowe Inspektora Ochrony Danych są tożsame z danymi kontaktowymi Administratora wskazanymi w zdaniu poprzednim.',
    'Dane osobowe będą przetwarzane w celach wykonywania zawartej umowy cywilno-prawnej oraz zgodnie z treścią udzielonych Administratorowi zgód. Podstawą prawną przetwarzania są czynności związane z wykonaniem umowy, wypełnienie obowiązku prawnego ciążącego na Administratorze wynikającego z przepisów administracyjnych oraz zgoda osoby, której dane dotyczą. Podanie danych jest obowiązkiem wynikającym z przepisów administracyjnych, a ich nie podanie będzie skutkowało nie zawarciem umowy. Odbiorcami danych osobowych są uprawnione organy publiczne.',
    'Dane będą przetwarzane w okresie 10 lat (przedawnienie roszczeń), do czasu, w którym ustanie cel dla którego zostały zebrane oraz zgodnie z terminami wskazanymi w przepisach administracyjnych, w zależności co nastąpi później. Każdy ma prawo żądania od Administratora dostępu do danych osobowych, ich sprostowania, usunięcia, ograniczenia przetwarzania, a także prawo do przenoszenia danych. Każdy ma prawo do cofnięcia zgody na przetwarzanie danych osobowych, którą udzielił Administratorowi. Wycofanie zgody nie ma wpływu na zgodność z prawem przetwarzania, którego dokonano przed jej cofnięciem. Każdy ma prawo do wniesienia skargi do Organu Nadzorczego (po 25 maja 2018 r.: do Prezesa Urzędu Ochrony Danych Osobowych.',
];

export const DEFAULT_ERROR_MESSAGE =
    'Nieoczekiwany błąd. Spróbuj ponownie lub skontaktuj się z BOK';

export const TERMS_URL = 'https://taniec.com.pl/ch/regulamin/';

export const getRegistrationTextByStatus = (status) => {
    let txt = DEFAULT_ERROR_MESSAGE;

    if (typeof status === 'string') {
        if (status == 'strUserRegistered') {
            txt =
                'Konto zostało zarejestrowane, na podany adres został wysłany link aktywacyjny. Kliknij w link i aktywuj konto.';
        } else if (status === 'strInactiveUser') {
            /*txt = 'Konto nie zostało potwierdzone, czy wysłać ponownie link do potwierdzenia?' */
            txt = 'Konto zostało już zarejestrowane, ale nie zostało potwierdzone';
        } else if (status === 'strActiveUser') {
            txt =
                'Podane konto istnieje już w naszym systemie. Jeśli nie pamiętasz hasła do logowania, skorzystaj z opcji resetowania hasła.';
        } else if (status === 'strMultipleActiveUsers') {
            txt = 'Prośba o kontakt z BOK, konto zablokowane.';
        } else if (status === 'strLoginUpdated') {
            txt =
                'Konto utworzone przez BOK, prośba o sprawdzenie wiadomości i potwierdzenie poprawności adresu email oraz ustawienie hasła.';
        } else if (status === 'strErrorOnLoginUpdate') {
            txt =
                'Błąd podczas aktywacji konta, proszę spróbować później lub skontaktować się z BOK';
        } else if (status == 'strAnotherUserWithEmailOrPesel') {
            txt = 'Konto już wykorzystywane, prośba o skontaktowanie się z BOK';
        } else if (status === 'strErrorOnUserRegistration') {
            // default text
        } else {
            // default text
        }
    }
    return txt;
};

export const getReadableCreditCardInfo = (cardData) => {
    if (typeof cardData === 'object' && cardData !== null) {
        let cardType = '';
        if (typeof cardData.cardType === 'string' && cardData.cardType.length > 0) {
            cardType = cardData.cardType;
        }

        let cardNumber = '';
        if (typeof cardData.mask === 'string' && cardData.mask.length > 0) {
            const splitCardNumber = cardData.mask.match(/.{1,4}/g);
            if (Array.isArray(splitCardNumber) && splitCardNumber.length > 0) {
                cardNumber = splitCardNumber.join(' ');
            }
        }

        let responseParts = [];
        if (cardType.length > 0) responseParts.push(cardType);
        if (cardNumber.length > 0) responseParts.push(cardNumber);

        return responseParts.join(' ').toUpperCase();
    } else return '';
};

export const getAddedSubAccountSummary = () => {
    const name = localStorage.getItem('addedSubAccountFullName');
    localStorage.removeItem('addedSubAccountFullName');

    if (typeof name === 'string' && name.length > 0) {
        return (
            <span>
                <p className="text-large">Dodałeś</p>
                <p className="related-added__name margin-top-8">{name}</p>
                <p className="text-large margin-top-8">jako osobę powiązaną.</p>
                <p className="margin-top-32">
                    Osoby powiązane możesz edytować z poziomu swojego profilu.
                </p>
            </span>
        );
    } else {
        return (
            <span>
                <p className="text-large">Dodałeś osobę powiązaną</p>
                <p className="margin-top-32">
                    Osoby powiązane możesz edytować z poziomu swojego profilu.
                </p>
            </span>
        );
    }
};

export const isValidDate = (date) => {
    if (typeof date === 'object' && date instanceof Date && !isNaN(date.getTime())) {
        return true;
    } else {
        return false;
    }
};
